export default "__VITE_ASSET__BWwZbJvj__"